import {
  DateOptionType,
  ExpenseType,
  FilingType,
  FinanceType,
  LanguageType,
  PP30FilingRoundType,
  PP30FormStatus,
  PP30TaxCreditType,
  PP30TaxRefundType,
  TransactionType,
} from "@/enums/enums";
import { ContactModel } from "../contact/contactModel";
import { MerchantDetail } from "../merchant/merchantModel";
import { UserInfoModel } from "../user/userModel";
import {
  ColumnModel,
  CredentialModel,
  ElementDefaultModel,
  ElementHeadTypeModel,
  ElementMerchantModel,
  ElementUserApproveModel,
  ElementUserCreateModel,
} from "./documentModel";
import { SettingPP30DocumentTemplateModel } from "./settingDocumentTemplate";

export class PP30DocumentModel {
  pp30Id!: number;
  createUserId!: number;
  createDateTime!: Date;
  updateUserId!: number;
  updateDateTime!: Date;
  approveUserId!: number;
  approveDateTime!: Date;
  status!: PP30FormStatus;
  isFiled!: boolean;
  isClosingEntry!: boolean;
  isPaid!: boolean;
  isDeleted!: boolean;
  formNumber!: string;
  formDate!: Date;
  vatZeroSaleAmount!: number;
  vatExcemptedSaleAmount!: number;
  vatApplicableSaleAmount!: number;
  vatZeroPurchaseAmount!: number;
  vatExcemptedPurchaseAmount!: number;
  vatClaimablePurchaseAmount!: number;
  salesTaxAmount!: number;
  purchaseTaxAmount!: number;
  saleTotal!: number;
  purchaseTotal!: number;
  remainingTaxCreditAmount!: number;
  interestAmount!: number;
  fineAmount!: number;
  vatToPayTotal!: number;
  vatToRefundTotal!: number;
  changeTaxCreditAmount!: number;
  netTaxAmount!: number;
  countSaleTransaction!: number;
  countPurchaseTransaction!: number;
  filingType!: FilingType;
  filingRound!: number;
  filingRoundType!: PP30FilingRoundType;
  taxCreditType!: PP30TaxCreditType;
  taxRefundType!: PP30TaxRefundType;
  createdDateTime!: Date;
  createdUser!: UserInfoModel;
  updatedDateTime!: Date;
  updatedUser!: UserInfoModel;
  approvedDateTime!: Date;
  merchant!: MerchantDetail;
  approvedUser!: UserInfoModel;
  tags!: Array<string>;
  pp30TransactionPurchaseTaxModelList!: Array<PP30TransactionModel>;
  pp30TransactionSalesTaxModelList!: Array<PP30TransactionModel>;
}

export class PP30DocumentDetailModel {
  data!: PP30DocumentModel;
  version!: number;
}

export class PP30OnlineViewModel {
  document!: PP30DocumentDetailModel;
  template!: SettingPP30DocumentTemplateModel;
  transactionId!: number;
  transactionType!: number;
  financeType!: number;
  expenseType!: number;
  headerOptionType!: number;
  credential!: CredentialModel;
  isMainTemplate!: boolean;
  doesHaveOwnTemplate!: boolean;
}

export class PP30DocumentTemplateModel {
  transactionType!: TransactionType;
  pp30FormNumber!: string;
  taxPeriodDate!: Date;
  filingType!: FilingType;
  times!: number;
  filingRoundType!: PP30FilingRoundType;
  pp30TaxCreditType!: PP30TaxCreditType;
  pp30TaxRefundType!: PP30TaxRefundType;
  merchant!: MerchantDetail;
  vatZeroSaleAmount!: number;
  vatExcemptedSaleAmount!: number;
  vatApplicableSaleAmount!: number;
  salesTaxAmount!: number;
  vatZeroPurchaseAmount!: number;
  vatExcemptedPurchaseAmount!: number;
  vatClaimablePurchaseAmount!: number;
  purchaseTaxAmount!: number;
  saleTotal!: number;
  purchaseTotal!: number;
  countSaleTransaction!: number;
  countPurchaseTransaction!: number;
  netTaxAmount!: number;
  vatToPayTotalThisMonth!: number;
  vatToRefundTotalThisMonth!: number;
  changeTaxCreditAmount!: number;
  vatToPayTotal!: number;
  vatToRefundTotal!: number;
  remainingTaxCreditAmount!: number;
  interestAmount!: number;
  fineAmount!: number;
  taxTotal!: number;
  taxTotalOverpaid!: number;
  userCreate!: ElementUserCreateModel;
  userApprove!: ElementUserApproveModel;
  merchantStampUrl!: ElementDefaultModel;
  pp30TransactionPurchaseTaxModelList!: Array<PP30TransactionModel>;
  pp30TransactionSalesTaxModelList!: Array<PP30TransactionModel>;
  isDeleted!: boolean;
  financeType!: FinanceType;
  expenseType!: ExpenseType;
  header!: HeaderPP30TransactionDocumentModel;
  detail!: DetailPP30TransactionDocumentModel;
  footer!: FooterPP30TransactionDocumentModel;

  constructor() {
    this.header = new HeaderPP30TransactionDocumentModel();
    this.detail = new DetailPP30TransactionDocumentModel();
    this.footer = new FooterPP30TransactionDocumentModel();
  }
}

export class PP30TransactionModel {
  id!: number;
  documentContactModel!: ContactModel;
  sourceType!: number;
  sourceId!: number;
  taxInvoiceNumber!: string;
  taxInvoiceDate!: Date;
  taxInvoiceType!: number;
  financeType!: number;
  reference!: string;
  vatExemptedTotal!: number;
  zeroVatTotal!: number;
  preVatTotal!: number;
  vatTotal!: number;
  subTotal!: number;
  netTotal!: number;
  sequenceNumber!: number;
}

export class HeaderPP30TransactionDocumentModel {
  colorCode!: string;
  isShowColorBackground!: boolean;
  isShowColorBorder!: boolean;
  language!: LanguageType;
  merchantLogo!: ElementDefaultModel;
  headType!: ElementHeadTypeModel;
  merchant!: ElementMerchantModel;
  documentInfo!: ElementPP30TransactionInfoModel;
  documentName!: ElementDefaultModel;
}

export class ElementPP30TransactionInfoModel {
  dateOptionType!: DateOptionType;
  formNumberTitle!: ElementDefaultModel;
  formDateTitle!: ElementDefaultModel;
  issueDateTitle!: ElementDefaultModel;
  formNumber!: string;
  formDate!: Date;
  issueDate!: Date;
  isCustomTextDisplay!: boolean;
}

export class DetailPP30TransactionDocumentModel {
  itemList!: Array<ElementPP30TransactionItemModel>;
  settingVatFormType!: number;
}

export class ElementPP30TransactionItemModel {
  sequenceNumber!: number;
  taxInvoiceDate!: Date;
  taxInvoiceNumber!: string;
  contact!: ContactModel;
  vatExemptedTotal!: number;
  zeroVatTotal!: number;
  preVatTotal!: number;
  vatTotal!: number;
}

export class FooterPP30TransactionDocumentModel {
  itemPurchase!: number;
  preVatPurchaseAmount!: number;
  vatExemptedPurchaseTotal!: number;
  zeroVatPurchaseTotal!: number;
  preVatPurchaseTotal!: number;
  vatPurchaseTotal!: number;
  itemSale!: number;
  preVatSaleAmount!: number;
  vatExemptedSaleTotal!: number;
  zeroVatSaleTotal!: number;
  preVatSaleTotal!: number;
  vatSaleTotal!: number;
  certified!: ElementPP30TransactionCertifiedModel;

  constructor() {
    this.itemPurchase = 0;
    this.preVatPurchaseAmount = 0;
    this.vatExemptedPurchaseTotal = 0;
    this.zeroVatPurchaseTotal = 0;
    this.preVatPurchaseTotal = 0;
    this.vatPurchaseTotal = 0;
    this.itemSale = 0;
    this.preVatSaleAmount = 0;
    this.vatExemptedSaleTotal = 0;
    this.zeroVatSaleTotal = 0;
    this.preVatSaleTotal = 0;
    this.vatSaleTotal = 0;
    this.certified = new ElementPP30TransactionCertifiedModel();
  }
}

export class ElementPP30TransactionCertifiedModel {
  userCreateTitle!: ElementDefaultModel;
  userApproveTitle!: ElementDefaultModel;
  userCreate!: ElementUserCreateModel;
  userApprove!: ElementUserApproveModel;
  isCustomTextDisplay!: boolean;
  isShowQRCode!: boolean;
}

export class HeaderSalePP30TransactionColumnModel {
  index!: ColumnModel;
  taxInvoiceDate!: ColumnModel;
  taxInvoiceNumber!: ColumnModel;
  contact!: ColumnModel;
  taxId!: ColumnModel;
  branch!: ColumnModel;
  preVatAmount!: ColumnModel;
  vatExemptedTotal!: ColumnModel;
  zeroVatTotal!: ColumnModel;
  preVatTotal!: ColumnModel;
  vatTotal!: ColumnModel;
}

export class HeaderPurchasePP30TransactionColumnModel {
  index!: ColumnModel;
  taxInvoiceDate!: ColumnModel;
  taxInvoiceNumber!: ColumnModel;
  contact!: ColumnModel;
  taxId!: ColumnModel;
  branch!: ColumnModel;
  preVatTotal!: ColumnModel;
  vatTotal!: ColumnModel;
}
